export const buttonsExample: string = `
  /// Buttons without progress state

  // Regular button
  <button className="button-primary">Shop Now</button>

  // Disabled button
  <button className="button-primary" disabled>Add To Cart</button>

  // Additional sizes (md, sm, xs)
  <button className="button-primary-md">Add to Cart</button>

  <button className="button-invert-sm">Cancel</button>

  <button className="button-ghost-xs">Buy Now</button>
  `;

export const buttonProgressExample: string = `
  /// Buttons with progress state (React only)

  import ButtonWithProgress from '../_shared/ui-components/YogaUI/ButtonWithProgress';

  const [shouldShowProgressAnimation, setShouldShowProgressAnimation] = useState(false);

  const options = {
    showProgressAnimation: shouldShowProgressAnimation, // Dynamic variable
    buttonClass: 'button-primary', // Pass the desired class of button
    cta: 'Global p.', // Pass the desired CTA text
  }

  <ButtonWithProgress options={options}/>


  /// Props
  Accepts options object:

  showProgressAnimation: boolean;
  cta: string;
  buttonTypeClass?: 
  | 'button-primary'
  | 'button-ghost'
  | 'button-dim'
  | 'button-invert'
  | 'button-primary-md'
  | 'button-ghost-md'
  | 'button-dim-md'
  | 'button-invert-md';
  wrapperClasses?: string;
  buttonClasses?: string;
  type?: 'button' | 'submit' | 'reset';
  `;

export const checkboxExample: string = `
  /// Anywhere outside of React

  // Make sure to provide a unique ID and htmlFor attributes for each use

  // Unchecked (rest)
  <div className="yoga-ui-checkbox">
    <input id="checkbox" type="checkbox" />
    <label htmlFor="checkbox">Checkbox</label>
  </div>

  // Checked
  <div className="yoga-ui-checkbox">
    <input id="checkbox-checked" type="checkbox" checked />
    <label htmlFor="checkbox-checked">Checkbox</label>
  </div>

  // Disabled
  <div className="yoga-ui-checkbox">
    <input id="checkbox-disabled" type="checkbox" disabled />
    <label htmlFor="checkbox-disabled">Checkbox</label>
  </div>




  // React
  import Checkbox from '../_shared/ui-components/YogaUI/Checkbox';

  <Checkbox
    options={{
      id: 'react-checkbox',
      label: 'React checkbox',
      onChange: (event) => {
        console.log(event.target.checked);
      },
    }}
  />

  /// Props
  Accepts options object:

  id: string;
  label: string;
  defaultChecked?: boolean;
  disabled?: boolean;
  required?: boolean;
  value?: string;
  name?: string;
  onChange?: Callback fired when the state of the checkbox is changed;
  inputClasses?: string;
  wrapperClasses?: string;
  labelClasses?: string;
  `;

export const textInputExample: string = `
  /// Form Input (non-React)

  <div className="yoga-ui-text-input">
    <input
      type="email"
      id="inputUniqueID"
      className="yoga-ui-input"
      required
      placeholder="Label"
    />
    <label htmlFor="inputUniqueID">Label</label>

    // Error statement. Optional. Only add if input has an attribute 'required'
    <span>Please enter a valid email address</span>
  </div>


  /// React Form input
  import FormInput from '../_shared/ui-components/YogaUI/FormInput';

  <FormInput
    options={{
      id: 'reactInput',
      label: 'Phone',
      type: 'tel',
      required: true,
      errorText: 'Please enter a valid phone. Format: 123-456-7890',
      pattern: '[0-9]{3}-[0-9]{3}-[0-9]{4}',
    }}
  />


  /// Props
  Accepts options object:

  id: string;
  label: string;
  defaultValue?: string;
  pattern?: string;
  name?: string;
  type?: 'email' | 'text' | 'password' | 'search' | 'tel' |
          'url' | 'date' | 'datetime-local' | 'time' | 'week';
  required?: boolean;
  autocomplete?: string;
  disabled?: boolean;
  errorText?: string;
  captionText?: string;
  onInput?: Callback fired when the value of the input is changed.;
  wrapperClasses?: string;
  inputClasses?: string;
  labelClasses?: string;
  errorClasses?: string;
  captionClasses?: string;
  `;

export const aloSidebarExample = `
  NOTE: This component is only available in React as it's built upon MUI drawer

  
  const DemoComponent = () => {

    // requires one state variable
    const [visible, setVisible] = React.useState(false);

    
    // JSX
    return (
      <button className="global-ghost-button" onClick={() => setVisible(true)}>
        open sidebar
      </button>

      <AloSidebar
        title="simple alosidebar"
        headerBorder={true}
        visible={visible}
        onClose={() => setVisible(false)}
        desktopWidth={560}
        mobileWidth={375}
        anchor="right"
      >
        <div>...</div>   // children like JSX (like div, p, form etc.) or other React component
      </AloSidebar>
    );
  };

  // accepted props:-

  anchor?: 'top' | 'right' | 'bottom' | 'left';   // AloSidebar direction

  headerBorder?: boolean;                         // title's border

  wrapperClass?: string;                          // wrapper CSS class for AloSidebar

  onClose: () => void;                            // Callback function when close icon or  
                                                  // background of AloSidebar is clicked
                                                  // i.e. we can use to set "visible" property here

  title: string;                                  // sets AloSidebar's title

  visible: boolean;                               // useful to open/close the AloSidebar

  desktopWidth?: number | string;                 // width for desktop version

  mobileWidth?: number | string;                  // widh for mobile version

  children: React.ReactNode;                      // any ReactNode (JSX or React Component)
`;

export const radioInputExample: string = `
  /// Radio Input (non-React)

    <div class="alo-radio-button">
      <input
        type="radio"
        id="IdExample"
        name="name-example"
        value="value"
        checked="true" // Checked by default true/false
      />
      <label for="name-example">Radio Button Label</label>
    </div>

  // React Radio input
  import AloRadioButton from '../_shared/ui-components/YogaUI/AloRadioButton';

  <AloRadioButton
    label="Radio Button Label" 
    value="value" 
    groupName="name-example"
  />


  /// Props

  value: string | number;
  label: string | ReactNode;
  disabled?: boolean; // Disable the entire radio group
  checked?: boolean;
  customClassName?: string; // Custom styles
  labelClasses?: string; // Custom styles
  onSelect?: (event: ChangeEvent<HTMLInputElement>) => void; // Callback on selection change
  groupName: NonEmptyString<string>;

  `;
